module.exports = __webpack_public_path__ + "media/fonts/Oricons-87735a05d98b52ff17a41ea3c31ef1a9.ttf";